import React from "react";
import { prefix } from "../../../wui-core/src/index.js";

var defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
  if (customizePrefixCls) return customizePrefixCls;
  return suffixCls ? "".concat(prefix, "-").concat(suffixCls) : prefix;
};

export var ConfigContext = /*#__PURE__*/React.createContext({
  getPrefixCls: defaultGetPrefixCls
});


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-menu/src/config-provider/index.js